<div
    class="option-group-name"
    [ngClass]="showSuspendedSelection || optionGroup.online ? 'clickable' : 'nonClickable'"
    (click)="handleHeaderClick($event)">
    <div class="option-group-header-title" [class.expanded]="!collapsed" [class.precreated-bab-group-name]="isPrecreatedBuildABet">
        @if (isPrecreatedBuildABet && isPrecreatedBetBuilderBadgeEnabled) {
            <span class="bet-builder-icon"> {{ sitecore.globalMessages.BetBuilderBadgeText }}</span>
        }
        <div class="header-content">
            @if (showEventName) {
                <div class="header-left">
                    <a class="event-info" (click)="goToEvent($event)">
                        <div class="event-name">{{ event.name }}</div>
                        <div class="event-metadata">
                            @if (showEventTimer && event.scoreboard && event.scoreboard.started) {
                                <i class="live-icon">{{ sitecore.event.Live }}</i>
                            }
                            @if (showEventTimer) {
                                <ms-event-timer class="event-timer" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
                            }
                        </div>
                    </a>
                </div>
            } @else {
                <div class="option-group-name-info-name">
                    <span class="market-name">{{ optionGroup.name }}</span>
                    @if (!deviceService.isMobile && winMarketName) {
                        <span class="option-group-win-market-desktop"> {{ winMarketName }}</span>
                    }
                </div>
            }

            @if (showMarketHelpToggle && optionGroup.online && !collapsed) {
                <ms-market-help-toggle [optionGroup]="optionGroup" [selected]="showMarketHelp" (selectedChange)="toggleMarketHelp($event)" />
            }
            @if (showPrecreatedBetBuilderNewBadge) {
                <span class="bet-builder-newbadge"> {{ sitecore.betBuilder.messages?.PrecreatedBuildABetNewBadgeText }}</span>
            }
        </div>

        <div class="option-group-header-right-section">
            @if (enableCorrectScoreOptionGroupToggle) {
                <ms-toggle-view-button />
            }
            @if (deviceService.isMobile && winMarketName) {
                <div class="option-group-win-market-mobile">
                    <span>{{ winMarketName }}</span>
                </div>
            }
            @if (marketLogoShowInHeader) {
                <ms-marketsubtype-logo
                    [eventId]="event.id"
                    [marketType]="marketType"
                    [marketSubType]="marketSubType"
                    [matchName]="event.name"
                    [sportId]="event.sport.id"
                    [trackingLocation]="'edp'"
                    [tooltipAppendTo]="tooltipAppendto ?? ''"
                    [tooltipBoundaries]="tooltipAppendto ?? ''"
                    [tooltipPlacement]="NgxFloatUiPlacements.BOTTOMEND"
                    [chevronShown]="shouldShowChevron"
                    [templateId]="templateId" />
            }
            @if (isBetBuilderBadgeVisible()) {
                @if (isBetMgmTheme) {
                    <ms-sgp-badge size="large" />
                } @else {
                    <ms-market-header-bet-builder-badge />
                }
            }
            @if (!optionGroup.online) {
                <div [ngClass]="showSuspendedSelection ? 'lock-icon-div' : ''">
                    <vn-icon
                        [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"
                        [size]="isEpcotEnabled ? '12' : '14'"
                        [ngClass]="{ 'option-group-lock-icon': !isEpcotEnabled }" />
                </div>
            }
            @if (promoted) {
                <div class="promotion-badge-icon">
                    <vn-icon name="theme-badge" [size]="isEpcotEnabled ? '12' : '14'" />
                </div>
            }
            @if (optionGroup.extended) {
                <ms-extended-offer />
            }
            @if ((showSuspendedSelection || optionGroup.online) && toggleable && shouldShowChevron) {
                <div class="option-group-header-chevron">
                    <vn-icon [name]="collapsed ? 'theme-down' : 'theme-up'" [size]="isEpcotEnabled ? '16' : '12'" />
                </div>
            }
            @if (showEventChevron && isLinkToEvent) {
                <vn-icon name="theme-right" [size]="isEpcotEnabled ? '12' : '14'" />
            }
            @if (shouldShowCloseBtn) {
                <button class="btn btn-secondary btn-md option-group-header-right-section-close close-overlay" (click)="closePanel()">
                    {{ sitecore.betBuilderEntainUI.messages?.OverlayClose }}
                </button>
            }
        </div>
    </div>
</div>
